import React, { useState, useEffect, createRef, RefObject } from 'react'
import Grid from '@material-ui/core/Grid';
import { LocalPersistence } from '../../factories';
//import { useLanguage } from '../../store/languageContext'
import { Paper } from '@material-ui/core';
import DetailItem from '../CSIComponents/DetailItem';
import { Tag,  Row, Col,message, Empty } from 'antd';
import {getImages} from '../../services/images'
import ImageGallery from 'react-image-gallery';
import './index.css';
import Loading from '@components/Loading';
import ReactImageGallery from 'react-image-gallery';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { SESSION_KEYS } from '../../constants';
import is from 'date-fns/esm/locale/is/index.js';


const Images = () => {
    //const { language } = useLanguage()
    //const lang = new LanguageFactory(language)
    // const [detailData, setDetailData ] = useState<any>({})
    const [imagesList, setImagesList] = useState<any>([])
    const [index, setIndex] = useState<any>(0)
    const [isLoading, setisLoading] = useState<boolean>(true)
    const getTableData = async () => {
        const get_session = new LocalPersistence(SESSION_KEYS.SESSION)
        const get_session_params = new  LocalPersistence(SESSION_KEYS.PROPERTY_PARAMS_SESSION)
        const session: any = await get_session.getSessionPersistence()
        const params: any = await get_session_params.getSessionPersistence()
        let supplier 

        if (params.selectedSupplier?.chainName) {
            supplier = params.selectedSupplier?.chainName
          } else {
            supplier = params.selectedSupplier
        }
    
       
        let propertyId = session.propertyId
        
        getImages(supplier,propertyId).then(data=>{

            setImagesList(data?.property?.images)
            setisLoading(false);
            console.log(data?.property?.images)
        },err=>{
            message.error({
                content: err.message || err.error[0].message
            });
            setImagesList([])
        })
    }
    const galleryRef:RefObject<ReactImageGallery> = createRef()
    let detailData: any = {}
    imagesList.forEach((item: any,index1:number) => {
        if(index) {
            if(index1 == index) {
                detailData=item
            }
        } else {
            if(index1 == 0) {
                detailData=item
            }
        }
        
    })
    //const sizes = "(max-width: 400px) 50vw, (max-width: 960px) 50vw, 50vw" 
    let filterData:any = [];
    imagesList.forEach((item:any)=> {
        filterData.push({'imageid':item.imageid, 'original':item.url,'thumbnail':item.url})
    })
    const detailDatas = [
        { label:'Image URL', value:detailData&&detailData.url?detailData.url:'', span:18 },
        {span:5},
        { label:'Image Width', value:detailData&&detailData.width?detailData.width:'', span:6 },
        { label:'Image Hieght', value:detailData&&detailData.height?detailData.height:'', span:6 },
        { label:'Last Updated', value:detailData&&detailData.lastupdated?detailData.lastupdated:'', span:6 },
        {span:5},
        { label:'Resolution', value:detailData&&detailData.resolution?detailData.resolution:'', span:6 },
        { label:'Image ID', value:detailData&&detailData.imageid?detailData.imageid:'', span:6 },
        { label:'Category', value:detailData&&detailData.category?detailData.category:'', span:6 },
        {span:5},

        { label:'Start Date', value:detailData&&detailData.startdate?detailData.startdate:'', span:6 },
        { label:'End Date', value:detailData&&detailData.enddate?detailData.enddate:'', span:6 },
        { label:'Source', value:detailData&&detailData.source?detailData.source:'', span:6 },
        {span:5},

        { label:'Flie Size', value:detailData&&detailData.size?detailData.size:'', span:6 },
        { label:'Sort Order', value:detailData&&detailData.sortorder?detailData.sortorder:'', span:6 },
        { label:'Unit Of Measure', value:detailData&&detailData.uom?detailData.uom:'', span:6 },
        {span:5},
        { label:'Caption', value:detailData&&detailData.caption?detailData.caption:'' , span:18 },
        {span:5},
    ]
    const tags = detailData.tags
    const callback = (e:any)=> {
        setIndex(e)
    }
    useEffect(() => {
        getTableData()
    }, [])
    return (
            <Paper style={{margin: '0 16px'}}>
                {
                    isLoading ? 
                    <Loading type="large" /> :
                    imagesList.length > 0 ? 
                    <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Images</div>
                        </div>
                        
                    </Grid>
                    <div className="image-gallery-wrap" style={{width:'40vw', margin:'auto'}}> 
                    {/* onErrorImageURL */}
                        <ImageGallery 
                            items={filterData} 
                            onSlide={(e)=>callback(e)} 
                            renderPlayPauseButton={()=>null} 
                            renderFullscreenButton={()=>null} 
                            infinite={false}
                            ref = {galleryRef}
                            renderCustomControls={
                                ()=><>
                                <LeftOutlined  
                                    className = {`image-gallery-custom-action left-thumbnail-navigation ${index===0&&'humbnail-navigation-disalbed'}`}  
                                    onClick = {()=>{
                                        let wrapWidth = document.querySelector('.image-gallery-wrap')?.clientWidth || 100
                                        let thumbnailWidth = document.querySelector('.image-gallery-thumbnail-image')?.clientWidth || 100
                                        let thumbnailCount = Math.floor((wrapWidth / thumbnailWidth))
                                        let nextIndex = index -thumbnailCount
                                        if(nextIndex>0){
                                            galleryRef?.current?.slideToIndex(nextIndex)
                                        }else{
                                            galleryRef?.current?.slideToIndex(0)
                                        }
                                    }} 
                                />
                                <RightOutlined  
                                    className = {`image-gallery-custom-action right-thumbnail-navigation ${index===(filterData.length-1)&&'humbnail-navigation-disalbed'}`}  
                                    onClick = {()=>{
                                        let wrapWidth = document.querySelector('.image-gallery-wrap')?.clientWidth || 100
                                        let thumbnailWidth = document.querySelector('.image-gallery-thumbnail-image')?.clientWidth || 100
                                        let thumbnailCount = Math.floor((wrapWidth / thumbnailWidth) + 0.5)
                                        let nextIndex = index + thumbnailCount - 1
                                        let imageCount = filterData.length
                                        if(nextIndex<=imageCount){
                                            galleryRef?.current?.slideToIndex(nextIndex)
                                        }else{
                                            galleryRef?.current?.slideToIndex(imageCount - 1)
                                        }
                                    }} 
                                />
                                </> }
                            />
                    </div>
                    <div style={{paddingLeft:32,}}>
                        <Row gutter={24}>
                             {detailDatas.map((item:any, i:number)=>{
                                return(
                                    <React.Fragment key={i}>
                                    {
                                        item.label?<Col span={item.span} key={i} className="col-margin">
                                        <DetailItem value={item.value} label={item.label} />
                                        </Col>:<Col span={item.span} key={i}></Col>
                                    }
                                    </React.Fragment>
                                    
                                    )
                                 })
                            }
                           
                            <div style={{display:'inline-block', width:'100%',marginBottom: '30px',fontWeight:600}}>
                                <div style={{width:'100%',fontSize:12,color:'#999999',height:'24px',paddingLeft:'13px'}}>Selected Tags</div>
                                <div style={{width:'100%',  padding:'0 5px', fontSize:'14px', height:'32px', margin:'5px 0 0 6px', lineHeight:'32px'}}>
                                    {
                                        tags&&tags.split(' | ').map((item:any, index: any) => {
                                            return <Tag key={index}>{item}</Tag>
                                        })
                                    }
                                </div>
                            </div>
                        {/* </Row> */}
                        </Row>
                    </div>
                    {/* <div className="col-2">
                    <p className="mr-2 f-13">Primary Language</p>
                        <TagViewerWithFlag flag={'isprimary'} data={languages} />
                    </div> */}
                </Grid>:<Empty 
                description={<span style={{color: 'black'}}>No images found for this property</span>}  
                /> 
                }
            </Paper>

    )
}

export default Images;

